"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const plds_tokens_1 = require("@paclife/plds.tokens");
const ButtonBase_1 = __importDefault(require("./ButtonBase"));
const Ripple_1 = __importDefault(require("./Ripple"));
const StyledButtonBase = styled_components_1.default(ButtonBase_1.default) `
  /**
    Font Styling
    Note: I am not using the Typography component here because it is difficult 
    to style the text in the hover/active states with it
  */
  font-family: ${plds_tokens_1.FontFamilies.openSans};
  font-style: normal;
  font-weight: ${plds_tokens_1.FontWeights[700]};
  font-size: ${plds_tokens_1.FontSizes.brandBody};
  line-height: ${plds_tokens_1.LineHeights[200]};

  border-radius: ${plds_tokens_1.Radii.rounded};

  /* Button Sizing */
  ${({ size, fullWidth, variant }) => {
    if (variant === "icon") {
        return styled_components_1.css `
        padding: ${plds_tokens_1.Spacing[8]};

        /* there are two size possibilites: small and medium */
        width: ${size === "small" ? plds_tokens_1.Spacing[32] : plds_tokens_1.Spacing[40]};
        height: ${size === "small" ? plds_tokens_1.Spacing[32] : plds_tokens_1.Spacing[40]};
      `;
    }
    if (variant === "text") {
        if (fullWidth) {
            return styled_components_1.css `
          padding: ${size === "small" ? plds_tokens_1.Spacing[4] : plds_tokens_1.Spacing[8]};
          width: 100%;
        `;
        }
        return styled_components_1.css `
        padding: ${size === "small" ? plds_tokens_1.Spacing[4] : plds_tokens_1.Spacing[8]};
        /* negative margin here so that button text is left-aligned */
        /* negative margin equals left padding */
        margin-left: -${size === "small" ? plds_tokens_1.Spacing[4] : plds_tokens_1.Spacing[8]};
      `;
    }
    if (size === "large") {
        return styled_components_1.css `
        padding: 12px ${plds_tokens_1.Spacing[24]};
        width: ${fullWidth ? "100%" : "auto"};
      `;
    }
    if (size === "medium") {
        return styled_components_1.css `
        padding: ${plds_tokens_1.Spacing[8]} ${plds_tokens_1.Spacing[24]};
        width: ${fullWidth ? "100%" : "auto"};
      `;
    }
    if (size === "small") {
        return styled_components_1.css `
        padding: ${plds_tokens_1.Spacing[4]} 12px;
        width: ${fullWidth ? "100%" : "auto"};
      `;
    }
    return undefined;
}}
`;
const PrimaryButton = styled_components_1.default(StyledButtonBase) `
  background-color: ${plds_tokens_1.Colors.blue600};
  color: ${plds_tokens_1.Colors.neutral0};
  border: ${plds_tokens_1.BorderWidths.regular} solid ${plds_tokens_1.Colors.blue600};

  /* styling to pass to icons */
  fill: ${plds_tokens_1.Colors.neutral0};
  stroke: ${plds_tokens_1.Colors.neutral0};

  &:hover {
    background-color: ${plds_tokens_1.Colors.blue700};
    border-color: ${plds_tokens_1.Colors.blue700};
    transition: background-color ${plds_tokens_1.Durations.medium}s, border-color ${plds_tokens_1.Durations.medium}s;
  }

  &:active {
    background-color: ${plds_tokens_1.Colors.blue800};
    border-color: ${plds_tokens_1.Colors.blue800};
  }

  &:focus-visible {
    border-color: ${plds_tokens_1.Colors.neutral0};
    box-shadow: 0px 0px 0px 2px ${plds_tokens_1.Colors.primary};
  }

  /* dark mode colors */
  ${({ dark }) => dark &&
    styled_components_1.css `
      background-color: ${plds_tokens_1.Colors.blue300};
      border-color: ${plds_tokens_1.Colors.blue300};
      color: ${plds_tokens_1.Colors.neutral1000};

      fill: ${plds_tokens_1.Colors.neutral1000};
      stroke: ${plds_tokens_1.Colors.neutral1000};

      &:hover {
        background-color: ${plds_tokens_1.Colors.blue200};
        border-color: ${plds_tokens_1.Colors.blue200};
        transition: background-color ${plds_tokens_1.Durations.medium}s, border-color ${plds_tokens_1.Durations.medium}s;
      }

      &:active {
        background-color: ${plds_tokens_1.Colors.blue100};
        border-color: ${plds_tokens_1.Colors.blue100};
      }

      &:focus-visible {
        border-color: ${plds_tokens_1.Colors.neutral0};
        box-shadow: 0px 0px 0px 2px ${plds_tokens_1.Colors.blue300};
      }
    `}

  ${({ disabled }) => disabled &&
    styled_components_1.css `
      background-color: ${plds_tokens_1.Colors.neutral100};
      border-color: ${plds_tokens_1.Colors.neutral100};
      color: ${plds_tokens_1.Colors.textDisabledLight};

      fill: ${plds_tokens_1.Colors.textDisabledLight};
      stroke: ${plds_tokens_1.Colors.textDisabledLight};
    `}
`;
const SecondaryButton = styled_components_1.default(StyledButtonBase) `
  background-color: transparent;
  color: ${plds_tokens_1.Colors.primary};
  border: ${plds_tokens_1.BorderWidths.hairline} solid ${plds_tokens_1.Colors.neutral500};

  fill: ${plds_tokens_1.Colors.primary};
  stroke: ${plds_tokens_1.Colors.primary};

  &:hover {
    border-color: ${plds_tokens_1.Colors.primary};
    color: ${plds_tokens_1.Colors.blue700};
    background-color: ${plds_tokens_1.Colors.blue100};
    transition: border-color ${plds_tokens_1.Durations.medium}s, color ${plds_tokens_1.Durations.medium}s, background-color ${plds_tokens_1.Durations.medium}s;

    fill: ${plds_tokens_1.Colors.primary};
    stroke: ${plds_tokens_1.Colors.primary};
  }

  &:active {
    color: ${plds_tokens_1.Colors.blue700};
    border-color: ${plds_tokens_1.Colors.neutral500};
    background-color: ${plds_tokens_1.Colors.neutral100};

    fill: ${plds_tokens_1.Colors.blue700};
    stroke: ${plds_tokens_1.Colors.blue700};
  }

  &:focus-visible {
    box-shadow: 0px 0px 0px 2px ${plds_tokens_1.Colors.primary};
  }

  ${({ disabled }) => disabled &&
    styled_components_1.css `
      color: ${plds_tokens_1.Colors.textDisabledLight};
      background-color: ${plds_tokens_1.Colors.neutral100};

      fill: ${plds_tokens_1.Colors.neutral300};
      stroke: ${plds_tokens_1.Colors.neutral300};
    `}
`;
const SecondaryNeutralButton = styled_components_1.default(StyledButtonBase) `
  background-color: transparent;
  color: ${plds_tokens_1.Colors.neutral1000};
  border: ${plds_tokens_1.BorderWidths.hairline} solid ${plds_tokens_1.Colors.neutral500};

  fill: ${plds_tokens_1.Colors.neutral1000};
  stroke: ${plds_tokens_1.Colors.neutral1000};

  &:hover {
    background-color: ${plds_tokens_1.Colors.neutral100};
    transition: background-color ${plds_tokens_1.Durations.medium}s;
  }

  &:active {
    background-color: ${plds_tokens_1.Colors.neutral200};
  }

  &:focus-visible {
    box-shadow: 0px 0px 0px 2px ${plds_tokens_1.Colors.primary};
  }

  ${({ disabled }) => disabled &&
    styled_components_1.css `
      color: ${plds_tokens_1.Colors.textDisabledLight};
      background-color: ${plds_tokens_1.Colors.neutral100};

      fill: ${plds_tokens_1.Colors.neutral300};
      stroke: ${plds_tokens_1.Colors.neutral300};
    `}
`;
// building on top of SecondaryButton styles
const TextButton = styled_components_1.default(SecondaryButton) `
  border: none;

  &:hover {
    /* hover styles are the same as that of SecondaryButton */
  }

  &:focus-visible {
    background-color: ${plds_tokens_1.Colors.blue200};
    color: ${plds_tokens_1.Colors.blue700};
    box-shadow: none;
  }

  &:active {
    background-color: ${plds_tokens_1.Colors.blue100};
    color: ${plds_tokens_1.Colors.blue700};
  }

  /* dark mode colors */
  ${({ dark }) => dark &&
    styled_components_1.css `
      color: ${plds_tokens_1.Colors.blue300};

      fill: ${plds_tokens_1.Colors.blue300};
      stroke: ${plds_tokens_1.Colors.blue300};

      &:hover {
        color: ${plds_tokens_1.Colors.blue200};
        background-color: ${plds_tokens_1.Colors.blue900};
        transition: background-color ${plds_tokens_1.Durations.medium}s, color ${plds_tokens_1.Durations.medium}s;

        fill: ${plds_tokens_1.Colors.blue200};
        stroke: ${plds_tokens_1.Colors.blue200};
      }

      &:active {
        color: ${plds_tokens_1.Colors.blue100};
        background-color: ${plds_tokens_1.Colors.blue800};

        fill: ${plds_tokens_1.Colors.blue100};
        stroke: ${plds_tokens_1.Colors.blue100};
      }

      &:focus-visible {
        background-color: ${plds_tokens_1.Colors.blue800};
        color: ${plds_tokens_1.Colors.blue300};

        fill: ${plds_tokens_1.Colors.blue300};
        stroke: ${plds_tokens_1.Colors.blue300};
      }
    `}

  ${({ disabled }) => disabled &&
    styled_components_1.css `
      background-color: transparent;
      color: ${plds_tokens_1.Colors.textDisabledLight};

      fill: ${plds_tokens_1.Colors.textDisabledLight};
      stroke: ${plds_tokens_1.Colors.textDisabledLight};
    `}
`;
// same styling as TextButton
// icon button size is determined in StyledButtonBase
const IconButton = styled_components_1.default(TextButton) ``;
const DestructiveButton = styled_components_1.default(StyledButtonBase) `
  background-color: ${plds_tokens_1.Colors.destructive};
  border-color: ${plds_tokens_1.Colors.destructive};
  color: ${plds_tokens_1.Colors.neutral0};

  fill: ${plds_tokens_1.Colors.neutral0};
  stroke: ${plds_tokens_1.Colors.neutral0};

  &:hover {
    background-color: ${plds_tokens_1.Colors.red700};
    border-color: ${plds_tokens_1.Colors.red700};
    transition: background-color ${plds_tokens_1.Durations.medium}s, border-color ${plds_tokens_1.Durations.medium}s;
  }

  &:active {
    background-color: ${plds_tokens_1.Colors.red800};
    border-color: ${plds_tokens_1.Colors.red800};
  }

  &:focus-visible {
    box-shadow: 0px 0px 0px 2px ${plds_tokens_1.Colors.neutral0}, 0px 0px 0px ${plds_tokens_1.Spacing[4]} ${plds_tokens_1.Colors.destructive};
  }

  ${({ disabled }) => disabled &&
    styled_components_1.css `
      background-color: ${plds_tokens_1.Colors.neutral300};
      border-color: ${plds_tokens_1.Colors.neutral300};
    `}
`;
const Label = styled_components_1.default.span `
  width: 100%;
  display: inherit;
  align-items: inherit;
  justify-content: inherit;
  fill: inherit;
  stroke: inherit;
`;
const IconSpan = styled_components_1.default.span `
  display: inherit;
  align-items: inherit;
  justify-content: inherit;
  position: relative;
  fill: inherit;
  stroke: inherit;

  /* styling applied to icons */
  > * {
    /* these values are inherited from its parent button component */
    fill: inherit;
    stroke: inherit;
  }
`;
const StartIconSpan = styled_components_1.default(IconSpan) `
  /* only add margin if variant is not 'icon' */
  margin-right: ${({ variant }) => (variant === "icon" ? 0 : plds_tokens_1.Spacing[8])};
`;
const EndIconSpan = styled_components_1.default(IconSpan) `
  /* only add margin if variant is not 'icon' */
  margin-left: ${({ variant }) => (variant === "icon" ? 0 : plds_tokens_1.Spacing[8])};
`;
const VariantMapping = {
    primary: PrimaryButton,
    secondary: SecondaryButton,
    secondaryNeutral: SecondaryNeutralButton,
    text: TextButton,
    icon: IconButton,
    destructive: DestructiveButton,
};
exports.Button = react_1.default.forwardRef((_a, ref) => {
    var { children, className, dark = false, disabled = false, endIcon = null, href, fullWidth = false, startIcon = null, size = "medium", variant = "primary" } = _a, others = __rest(_a, ["children", "className", "dark", "disabled", "endIcon", "href", "fullWidth", "startIcon", "size", "variant"]) // used to receive any native HTML element props
    ;
    // ensure that startIcon and endIcon are the right size
    // all icons are 16px except for the medium version of the icon button variant
    const iconSizeChooser = (buttonSize, buttonVariant) => {
        if (buttonSize === "medium" && buttonVariant === "icon") {
            return 24;
        }
        return 16;
    };
    const iconSize = iconSizeChooser(size, variant);
    let startIconWithWidth = null;
    if (startIcon) {
        startIconWithWidth = react_1.default.cloneElement(startIcon, { width: iconSize });
    }
    let endIconWithWidth = null;
    if (endIcon) {
        endIconWithWidth = react_1.default.cloneElement(endIcon, { width: iconSize });
    }
    // generate the right button variant to render
    const Component = VariantMapping[variant];
    return (react_1.default.createElement(Component, Object.assign({ className: className, variant: variant, dark: dark, disabled: disabled, href: href, fullWidth: fullWidth, size: size, ref: ref }, others),
        react_1.default.createElement(Label, null,
            startIcon && react_1.default.createElement(StartIconSpan, { variant: variant }, startIconWithWidth),
            children,
            endIcon && react_1.default.createElement(EndIconSpan, { variant: variant }, endIconWithWidth)),
        react_1.default.createElement(Ripple_1.default, null)));
});
//# sourceMappingURL=button.js.map